import { useState, useEffect } from "react";
import Login from "./Login";
import Dashboard from "./Dashboard";
import AddApp from "./AddApp";
import Applications from "./Applications";
import ApplicationDetail from "./ApplicationDetail";
import URLMonitoring from "./URLMonitoring";
import Clients from "./Clients";
import Developers from "./Developers";
import LLMModels from "./LLMModels";
import RelianceMatrix from "./RelianceMatrix";
import logo from "./mindpro_technologies_logo.png";
import { Routes, Route } from "react-router-dom";

export default function App() {
  const [role, setRole] = useState(null);

  // 🔥 FIX: RESTORE PAGE AFTER REFRESH
  const [page, setPage] = useState(
    localStorage.getItem("page") || "dashboard"
  );

  const [selectedApp, setSelectedApp] = useState(null);
  const [selectedEnv, setSelectedEnv] = useState(null);
  const [darkMode, setDarkMode] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const storedRole = localStorage.getItem("role");

    if (token && storedRole) {
      setRole(storedRole);
    } else {
      localStorage.clear();
      setRole(null);
    }
  }, []);

  // 🔥 SAVE PAGE WHENEVER IT CHANGES
  useEffect(() => {
    localStorage.setItem("page", page);
  }, [page]);

  // BACK BUTTON HANDLING
  useEffect(() => {
    const handlePopState = () => {
      if (page === "envDetail") {
        setPage("appDetail");
        setSelectedEnv(null);
      } else if (page === "appDetail") {
        setPage("applications");
        setSelectedApp(null);
      } else {
        setPage("dashboard");
      }
    };

    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, [page]);

  const logout = () => {
    localStorage.clear();
    localStorage.removeItem("page"); // 🔥 CLEAN PAGE
    setRole(null);
  };

  const goBack = () => {
    if (page === "envDetail") {
      setPage("appDetail");
      setSelectedEnv(null);
      window.history.pushState({}, "", "/app");
    } else if (page === "appDetail") {
      setPage("applications");
      setSelectedApp(null);
      window.history.pushState({}, "", "/applications");
    } else {
      setPage("dashboard");
      window.history.pushState({}, "", "/");
    }
  };

  if (!role) {
    return <Login setAuth={setRole} />;
  }

  return (
    <div style={{ display: "flex", alignItems: "flex-start" }}>

      {/* ================= SIDEBAR ================= */}
      <div
        style={{
          width: 240,
          minHeight: "100vh",
          background: "#1e293b",
          color: "white",
          padding: 20,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          position: "sticky",
          top: 0
        }}
      >
        <div>
          <h2>MPT APP Inventory</h2>

          {/* 🔥 ONLY CHANGE: no need to add localStorage here */}

          <div onClick={() => { setPage("dashboard"); window.history.pushState({}, "", "/"); }} style={menuStyle(page === "dashboard")}>
            📊 Dashboard
          </div>

          {role === "admin" && (
            <div onClick={() => { setPage("add"); window.history.pushState({}, "", "/add"); }} style={menuStyle(page === "add")}>
              ➕ Add App
            </div>
          )}

          <hr style={{ margin: "15px 0", borderColor: "#475569" }} />

          <div onClick={() => { setPage("applications"); window.history.pushState({}, "", "/applications"); }} style={menuStyle(page === "applications")}>
            📦 Applications
          </div>

          <div onClick={() => { setPage("llm"); window.history.pushState({}, "", "/llm"); }} style={menuStyle(page === "llm")}>
            🤖 LLM Models
          </div>

          <div onClick={() => { setPage("clients"); window.history.pushState({}, "", "/clients"); }} style={menuStyle(page === "clients")}>
            🟢 Live Clients
          </div>

          <div onClick={() => { setPage("reliance"); window.history.pushState({}, "", "/reliance"); }} style={menuStyle(page === "reliance")}>
            📊 Reliance Matrix
          </div>

          <div onClick={() => { setPage("developers"); window.history.pushState({}, "", "/developers"); }} style={menuStyle(page === "developers")}>
            👨‍💻 Developers
          </div>

          <div onClick={() => { setPage("urlMonitoring"); window.history.pushState({}, "", "/url-monitoring"); }} style={menuStyle(page === "urlMonitoring")}>
            🌐 URL Monitoring
          </div>
        </div>

        <button
          onClick={logout}
          style={{
            background: "#ef4444",
            color: "white",
            border: "none",
            padding: "10px",
            borderRadius: "6px",
            cursor: "pointer"
          }}
        >
          🚪 Logout
        </button>
      </div>

      {/* ================= MAIN CONTENT ================= */}
      <div
        style={{
          flex: 1,
          background: darkMode ? "#0f172a" : "#f1f5f9",
          color: darkMode ? "white" : "black",
          minHeight: "100vh",
          overflowY: "auto"
        }}
      >

        {/* HEADER */}
        <div
          style={{
            position: "sticky",
            top: 0,
            zIndex: 1000,
            background: darkMode ? "#020617" : "white",
            padding: "12px 20px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            boxShadow: "0 2px 6px rgba(0,0,0,0.1)"
          }}
        >
          <img src={logo} alt="Mindpro Logo" style={{ width: 42, height: 42 }} />

          <div style={{ fontSize: "20px", fontWeight: "bold" }}>
            Mindpro Technologies Application Inventory
          </div>

          <div style={{ display: "flex", gap: 10 }}>
            <button onClick={() => setDarkMode(!darkMode)}>
              {darkMode ? "☀️" : "🌙"}
            </button>
            <div>{role?.charAt(0)?.toUpperCase()}</div>
          </div>
        </div>

        <div style={{ padding: 20 }}>
          {(page === "appDetail" || page === "envDetail") && (
            <button onClick={goBack}>
              ⬅ Back
            </button>
          )}

          {page === "dashboard" && <Dashboard />}
          {page === "llm" && <LLMModels />}
          {page === "reliance" && <RelianceMatrix />}
          {page === "urlMonitoring" && <URLMonitoring />}
          {page === "add" && role === "admin" && <AddApp />}
          {page === "clients" && <Clients />}
          {page === "developers" && <Developers />}

          {page === "applications" && (
            <Applications
              setSelectedApp={(app) => {
                setSelectedApp(app);
                setSelectedEnv(null);
                setPage("appDetail");
                window.history.pushState({}, "", "/app");
              }}
            />
          )}

          {page === "appDetail" && (
            <ApplicationDetail
              app={selectedApp}
              setSelectedEnv={(env) => {
                setSelectedEnv(env);
                setPage("envDetail");
                window.history.pushState({}, "", "/env");
              }}
            />
          )}

          {page === "envDetail" && (
            <Dashboard filterApp={selectedApp} filterEnv={selectedEnv} />
          )}
        </div>
      </div>
    </div>
  );
}

function menuStyle(active) {
  return {
    cursor: "pointer",
    margin: "10px 0",
    padding: "10px",
    borderRadius: "6px",
    background: active ? "#334155" : "transparent"
  };
}
